import CarnetPaiementController from './carnet.paiement.controller';

export default {
    bindings: {
        modalInstance: '='
    },
    template: require('./carnet.paiement.html'),
    controller: CarnetPaiementController
};
